import {
  any, object, string,
} from 'prop-types';
import dynamic from 'next/dynamic';

import { useI18n } from 'context/i18n';
import Layout from 'components/layout';
import { HeadSEO } from 'components/base';
import { replaceUndefinedKeysForNull, COOKIES } from 'utils/helpers';
import { getCmsModule, initCMS } from 'utils/cms';
import { IS_CAMPER } from 'utils/constants';
import ProductsRow from 'components/ProductsRow';
import Product from 'components/product';
import nookies from 'nookies';

const HomeComponent = IS_CAMPER ? dynamic(
  () => import('@camper/react-web-components').then((res) => res.PAGES.HomeComponent),
) : dynamic(
  () => import('@nnormal/react-web-components').then((res) => res.PAGES.HomeComponent),
);
const defaultTitle = IS_CAMPER ? 'Camper Shoes - Official Online Shop' : 'Nnormal Shoes - Official Online Shop';

const slots = {
  products: ProductsRow,
  product: Product,
};
export default function Home({
  footerProps, homeProps, tnmProps, ribbon, metaTags,
}) {
  const { locale } = useI18n();

  return (
    <Layout
      footerProps={footerProps}
      tnmProps={tnmProps}
      breadcrumbs={false}
      scrollArrow={true}
      ribbon={ribbon}
      extratags={[ <link key='canonical' rel="canonical" href={`${process.env.INTEGRA_DOMAIN}/${locale}`} /> ]}
    >
      <div className="container">
        <HeadSEO
          title={metaTags?.pageTitle || defaultTitle}
          description={metaTags?.metaDescription || 'Buy new shoes, boots, sneakers and accessories from the collection. Contemporary designs, original spirit.  Free shipping and 2 years warranty.'}
          pageName={'home'}
        />
        <HomeComponent {...homeProps} slots={slots} />
      </div>
    </Layout>
  );
}

Home.propTypes = {
  lang: string,
  locale: string,
  defaultLocale: string,
  footerProps: any,
  tnmProps: any,
  homeProps: any,
  ribbon: any,
  metaTags: object,
};

Home.i18nPage = 'Home';

export async function getServerSideProps(context) {
  const locale = [ 'catchAll', 'int' ].includes(context.locale) ? 'es_ES' : context.locale;
  const {
    footerProps, tnmProps, ribbon, cmsContainer,
  } = await initCMS({ context, locale });

  const CMS = await getCmsModule();

  const [ metaTags, homeProps ] = await Promise.all([
    cmsContainer
      .resolve(CMS.ORGANISMS.MetaPropsService)
      .getProps(''),
    cmsContainer
      .resolve(CMS.PAGES.HomePropsService)
      .getProps(),

  ]);
  replaceUndefinedKeysForNull(homeProps);

  // control borrar bolsa fromEsw
  if (context.query.fromEsw === 'true') {
    nookies.destroy(context, COOKIES.SHIPPING_DATA);
    nookies.destroy(context, COOKIES.BAG);
    nookies.destroy(context, COOKIES.BAG_MARKET);
  }

  return {
    props: {
      rel_parents: [],
      locale: context.locale,
      defaultLocale: context.defaultLocale,
      footerProps,
      homeProps,
      tnmProps,
      ribbon,
      metaTags: metaTags ? { ...metaTags } : null,
    },
  };
}
